import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/actions/toastActions";
import { USER_LOGIN_SUCCESS } from "../../redux/constants/userConstants";

function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("id");
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues: {}, mode: "onChange" });

  async function onSubmit(data) {
    let mongoId = data?.mongoId?.trim();
    if (mongoId?.length !== 24) {
      dispatch(
        showToast({
          message: "Invalid Id",
          category: "danger",
        })
      );
      setLoading(false);
    } else {
      setLoading(true);

      axios({
        method: "GET",
        url: `${process.env.REACT_APP_SERVER_URL_LEADS}/user/login/exhibitor/${mongoId}`,
        withCredentials: true,
      })
        .then(async (response) => {
          localStorage.setItem("accessToken", response.data.accessToken);
          localStorage.setItem("refreshToken", response.data.refreshToken);
          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: {
              ...response.data.user,
              accessToken: response.data.accessToken,
              refreshToken: response.data.refreshToken,
            },
          });
          // dispatch({
          //   type: USER_LOGIN_SUCCESS,
          //   payload: {
          //     ...response.data.user,
          //     accessToken: response.data.accessToken,
          //     refreshToken: response.data.refreshToken,
          //   },
          // });
          navigate("/events?tab=upcoming");
          setLoading(false);
        })
        .catch((error) => {
          dispatch(
            showToast({
              message: "Sorry, Invalid Credentials",
              category: "danger",
            })
          );
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    if (uid?.trim()) {
      setLoading(true);
      setValue("mongoId", uid);
      onSubmit({ mongoId: uid });
    }
  }, [setValue, uid]);

  return (
    <>
      <div
        className={`flex items-center justify-center flex-col w-full sm:max-w-[1280px] mx-auto md:h-[calc(100vh-58px)] px-5`}
      >
        {/* <img
          src="/svgs/logo.svg"
          alt="logo"
          className="h-[55px] w-[55px] md:h-[35px] md:w-[35px] md:hidden"
        /> */}
        <div className={"flex items-center gap-[6px] md:hidden"}>
          <img
            src="https://s3.ap-south-1.amazonaws.com/app.warpbay1/8d8d5a61fdad9bfb52e531483fdacf46"
            alt="logo"
            className="h-[30px] w-[30px] md:h-[35px] md:w-[35px]"
          />
        </div>
        <p className="text-[35px] font-semibold text-center pt-2 text-gray-600">
          Lead Scanner
        </p>
        <p className="text-[18px] pt-1.5 text-gray-500">
          Sign into your account
        </p>

        <div className="w-full md:w-[400px] flex flex-col items-center text-gray-500 rounded-[10px] border my-2 bg-gray-50 text-center px-3 py-5">
          <p className="text-[25px] font-medium">Welcome</p>
          <p className="pt-1 ">
            Enter your unique code to access your account.
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="w-full">
            <input
              type={"text"}
              id="mongoId"
              placeholder="Enter your id"
              className={`my-5 w-full
                      peer bg-[#F4F6F9] border-[2px] border-primary text-gray-900 text-[14px] rounded-lg h-[50px] focus:ring-transparent focus:border-primary focus:border-[2px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
              required
              autoFocus={false}
              {...register("mongoId", {
                required: true,
              })}
            />

            <div className="pb-0 bg-white w-full ">
              <button
                type="submit"
                disabled={loading}
                className="bg-primary border text-white font-[500] rounded-[10px] h-[50px] text-[16px] px-2 w-full mt-0"
              >
                {loading ? "loading..." : "Login to Lead Scanner"}
              </button>
            </div>
          </form>
        </div>

        <p className="text-[13px] font-[500] text-center">
          By continuing you agree to the{" "}
          <span className="text-[#f36f21]">Term of Service</span> and{" "}
          <span className="text-[#f36f21]">Privacy Policy</span>
        </p>
        {/* <Card>
          <form
            className="max-w-[340px] flex flex-col gap-[20px]"
            onSubmit={handleSubmit(onSubmit)}
          >
            <p className="text-[22px] font-[700] block text-left mb-[10px]">
              Login to Warpbay!!
            </p>
            <div>
              <TextInput
                type="text"
                id="mongoId"
                required
                label="Enter your id"
                register={register}
                mb="0"
                // minLength={16}
                // maxLength={16}
              />
            </div>
            <input
              type="submit"
              value={loading ? "Loading..." : `Login`}
              className="primary_submit"
              disabled={loading}
            />
            <p className="text-[13px] font-[500]">
              By continuing you agree to the{" "}
              <span className="text-[#f36f21]">Term of Service</span> and{" "}
              <span className="text-[#f36f21]">Privacy Policy</span>
            </p>
          </form>
        </Card> */}
        {/* <ScanIcon /> */}
      </div>
    </>
  );
}

export default Login;
